// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eyVt","placeholdersHeader":"styles_placeholdersHeader__1US0f","editorStyle":"styles_editorStyle__Zs4G2","placeholdersBox":"styles_placeholdersBox__1xcwR"};